export enum MedicationTypeEnum {
  MEDICINAL_PRODUCT,
  MAGISTRAL,
  FREETEXT,
  SUBSTANCE_PRODUCT,
}

export const allMedicationTypes = (): Array<MedicationTypeEnum> => {
  return [
    MedicationTypeEnum.MEDICINAL_PRODUCT,
    MedicationTypeEnum.MAGISTRAL,
    MedicationTypeEnum.FREETEXT,
    MedicationTypeEnum.SUBSTANCE_PRODUCT,
  ];
};

export const mapStringToMedicationTypeEnum = (type?: string) => {
  switch (type && type.toUpperCase()) {
    case "MAGISTRAL":
      return MedicationTypeEnum.MAGISTRAL;
    case "MEDICINAL_PRODUCT":
      return MedicationTypeEnum.MEDICINAL_PRODUCT;
    case "SUBSTANCE_PRODUCT":
      return MedicationTypeEnum.SUBSTANCE_PRODUCT;
    case "FREETEXT":
    default:
      return MedicationTypeEnum.FREETEXT;
  }
};
